import React, { useState, useEffect } from 'react';
import { Card, Button, Message } from '@alifd/next';
import { Spin } from 'antd';
import axios from 'axios';
import Swal from 'sweetalert2';
import client from '../../../../lib/feathers';

const UpdateSystemBlock = () => {
  const [communityDataArr, setCommunityDataArr] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      (async () => {
        const newSystem = await axios.get('/ezcon/api/systemVersion', {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
        });
        setCommunityDataArr(newSystem.data);
      })();
    } catch (e) {
      console.log(e);
    }
  }, [loading]);

  useEffect(() => {
    client.io.on('systemUpdate', () => {
      setLoading(false);
    });
  }, []);

  return (
    <Card free>
      <Card.Content>
        <Spin spinning={loading} delay={500}>
          <div>目前版本號：{communityDataArr.localVersion}</div>
          <div>雲端版本號：{communityDataArr.remoteVersion}</div>
          {communityDataArr.remoteVersion !== communityDataArr.localVersion && (
            <Button
              onClick={async () => {
                try {
                  const result = await Swal.fire({
                    title: '您確定要更新系統?',
                    html: `<div>目前版本號：${communityDataArr.localVersion}</div><div>雲端版本號：${communityDataArr.remoteVersion}</div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#BEBEBE',
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                  });
                  if (result.isConfirmed) {
                    setLoading(true);
                    Swal.fire({
                      icon: 'info',
                      title: '系統更新中～請稍後!!',
                    });
                    await axios('/ezcon/api/systemDoUpgrade', {
                      method: 'GET',
                      headers: {
                        authorization: window.localStorage['feathers-jwt'],
                      },
                    });
                  }
                } catch (error) {
                  console.error(error);
                }
              }}
            >
              更新
            </Button>
          )}
        </Spin>
      </Card.Content>
    </Card>
  );
};

export default UpdateSystemBlock;
